import {useRef} from 'react'
import {Value} from 'react-native-reanimated'

const useValue = initialValue => {
    return useRef(new Value(initialValue)).current
}

export default useValue
